module.exports = __webpack_public_path__ + "img/logo23@2x.9f2f24b4.png";